module.exports = __webpack_public_path__ + "img/bottom-04.6047e1f0.png";